export const ERROR_SOCKET_CONNECTION = 'Socket connection error'
export const ERROR_NOT_SUPPORTED = 'This device is unsupported due to a low camera frame rate. Please use this application on a different device'
